import React from 'react';
import { Offer1,Offer2,Offer3 } from '../gadgets';
const WorkTrend = () => {
    return (
      <div>
            
          <h1>simple editing process.</h1>
    <div className='offerCont'>
          <img className='offerimg' src={Offer1.image } alt="baby" />
        <img className='offerimg' src={Offer2.image} alt="baby2" />
        <img className='offerimg' src={Offer3.image} alt="baby3" />
    </div>
      </div>
  );
}

export default WorkTrend;
